<template>
    <div class="col-xl-6 col-lg-6 col-sm-12">
        <div class="card browser-table">
          <div class="card-header pb-0">
            <h3>Usage in Browser</h3>
          </div>
          <div class="card-body">
            <div class="table-responsive mb-0 theme-scrollbar">
              <table class="table">
                <thead>
                  <tr>
                    <th>Browser</th>
                    <th>Name</th>
                    <th>Daily</th>
                    <th>Weekly</th>
                    <th>Monthly</th>
                  </tr>
                </thead>
                <tbody v-for="(item,index) in menu" :key="index">
                  <tr>
                    <td><img class="img-fluid" :src="item.browser" alt=""></td>
                    <td>{{item.name}}</td>
                    <td>{{item.daily}}</td>
                    <td>{{item.weekly}}</td>
                    <td>{{item.monthly}}</td>
                  </tr>
                 
                </tbody>
              </table>
            </div>
          
          </div>
        </div>
      </div>
</template>
<script>
import {BrowserData} from '../../../data/widgets/general/data'
export default{
    name :'browserPage',
    data(){
        return{
            menu: BrowserData
        }
    }
}
</script>